import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'
import styled from 'styled-components'
import Text from 'core-system/Text'
import RandomUtils from 'shared/RandomUtils'
import SecondaryButton from 'core-system/Button/SecondaryButton'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const SuccessMsgContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: ${(props) => props.theme.palette.success.green300};
  > div {
    color: ${(props) => props.theme.palette.success.green700};
  }
`

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 50%;
`

interface OnboardingFinchSyncProps {
  setLoading: (loading: boolean) => void
  setOnboardingStageToStripeSync: () => void
}

const OnboardingFinchSync = React.memo((props: OnboardingFinchSyncProps) => {
  const { setOnboardingStageToStripeSync } = props

  const { allFinchWorksites, profile } = useSelector(
    (state: AppState) => state.employer
  )

  const formattedProviderName = useMemo(
    () => RandomUtils.formatFinchProviderName(profile?.payrollProviderId),
    [profile?.payrollProviderId]
  )

  return (
    <Container>
      {/* Success message for finch connect */}
      <SuccessMsgContainer>
        <Text variant='action4' textAlign='center'>
          Congratulations! You have successfully connected with{' '}
          {formattedProviderName
            ? formattedProviderName
            : 'your payroll provider'}
        </Text>
      </SuccessMsgContainer>
      <ContentContainer>
        {/* If there are no Finch Worksites then we know that they are an assisted provider so we can move them to the next step */}
        <Text variant='action4'>
          {allFinchWorksites && allFinchWorksites.length === 0
            ? `Due to syncing limitations of Finch and ${formattedProviderName}, your workforce data may take up to 7 days to sync. We will notify you when your workforce data is ready to be integrated. Stay tuned!`
            : 'Select the worksites you would like to integrate into Fleet:'}
        </Text>
        <SecondaryButton
          onClick={() => setOnboardingStageToStripeSync()}
          style={{ marginTop: '1rem' }}
        >
          Add Payment Method
        </SecondaryButton>
      </ContentContainer>
    </Container>
  )
})

// Helps identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  OnboardingFinchSync.displayName = 'OnboardingFinchSync'
}

export default OnboardingFinchSync
